import Box from "ds/components/Box";
import Link from "ds/components/Link";
import BadgeNext from "ds/components/BadgeNext";
import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

import { CellComponentProps } from "../types";

type RolesListItemNameCellProps = CellComponentProps;

const RolesListItemNameCell = ({ role }: RolesListItemNameCellProps) => {
  const roleUrl = `/settings/role/${role.id}`;

  return (
    <Box fullWidth gap="large">
      {role.isSystem ? (
        <>
          <TextEllipsis tooltip={role.name} tooltipWidthMode="maxWidthSm">
            {(props) => (
              <Typography {...props} tag="p" variant="p-body3">
                {role.name}
              </Typography>
            )}
          </TextEllipsis>

          <BadgeNext type="strong" variant="blue" text="SYSTEM" />
        </>
      ) : (
        <Link
          analyticsPage={AnalyticsPageOrganization.OrganizationRoles}
          analyticsTitle="Role Name Clicked"
          analyticsProps={{
            roleName: role.name,
          }}
          size="small"
          variant="secondary"
          href={roleUrl}
        >
          {role.name}
        </Link>
      )}
    </Box>
  );
};

export default RolesListItemNameCell;
